
import serviceHome from '../../api/serviceHome'

const ServiceHomeSection = (props) => {
  const ClickHandler = () => {
    window.scrollTo(0, 0)
  }

  return (
    <section className={'' + props.hclass}>
      <div className="container-fluid p-0">
        {/* <div className=""> */}
        <h2 className="service-title fade_bottom">Home, Kitchen Supplies</h2>
        {/* </div> */}

       
        <div className="container">
          <div className="service-wrap">
          {serviceHome.slice(0, 12).map((service, index) => (
            <div className="service-card" key={index}>
              <div className="card-content">
                <img src={service.Icon} alt={service.title} />
                {/* <h2>{service.title}</h2>
                <p>{service.description}</p> */}
              </div>
            </div>
          ))}
        </div>
        
         
        </div>
       
      </div>
       {/* <div className="project-allBtn fade_bottom">
          <Link onClick={ClickHandler} to="/services" className="theme-btn">
            <span>All Services</span>
            <img src={Shape} alt="" />
          </Link>
        </div> */}
    </section>
  )
}

export default ServiceHomeSection
